export default "__VITE_ASSET__BQXY9Jf2__"